import React from 'react';
import { 
  FaBrain, 
  FaHeartbeat, 
  FaHeadSideVirus, 
  FaHeadSideCough,
  FaBug,
  FaHeadphones,
  FaBone,
  FaBackward,
  FaUserInjured,
  FaChevronRight,
  FaStethoscope,
  FaPlus,
  FaPhoneAlt,
  FaCalendarAlt,
  FaEye,
  FaMemory
} from 'react-icons/fa';
import '../style.css';

const NeuroSection = () => {
  const neuroConditions = [
    {
      id: 1,
      icon: <FaBrain />,
      title: "Brain Tumor",
      hindiTitle: "ब्रेन ट्यूमर",
      image: "https://th.bing.com/th/id/OIP.cyoYzbeRuCB69YczbgwwXwHaH3?&rs=1&pid=ImgDetMain&o=7&rm=3",
      description: "A brain tumor is an abnormal cell growth in the brain, which may be benign or malignant, leading to symptoms like headaches, seizures, memory problems, and changes in behavior.",
      symptoms: ["Headaches", "Seizures", "Memory Loss", "Personality Changes"],
      color: "var(--brain-color)"
    },
    {
      id: 2,
      icon: <FaHeartbeat />,
      title: "Paralysis / Brain Hemorrhage",
      hindiTitle: "लकवा/ब्रेन हेमरेज",
      image: "https://cdn.storymd.com/optimized/PApkyeTvq5/original.jpg",
      description: "A brain tumor is an abnormal cell growth in the brain, which may be benign or malignant, leading to symptoms like headaches, seizures, memory problems, and changes in behavior.",
      symptoms: ["Sudden Weakness", "Speech Difficulty", "Vision Problems", "Loss of Balance"],
      color: "var(--stroke-color)"
    },
    {
      id: 3,
      icon: <FaHeadSideVirus />,
      title: "Epilepsy / Seizures / Unconsciousness",
      hindiTitle: "मिर्गी / दौराआना / बेहोशी",
      image: "https://static.vecteezy.com/system/resources/previews/049/462/065/non_2x/unconscious-patient-in-hospital-emergency-room-critical-condition-with-vital-monitors-and-medical-equipment-photo.jpeg",
      description: "Epilepsy is a neurological disorder causing recurring seizures or sudden unconsciousness. It results from abnormal brain activity and may involve jerking movements, confusion, or loss of awareness. Treatment helps manage symptoms.",
      symptoms: ["Seizures", "Confusion", "Staring Spells", "Loss of Consciousness"],
      color: "var(--epilepsy-color)"
    },
    {
      id: 4,
      icon: <FaHeadSideCough />,
      title: "Head Injury",
      hindiTitle: "सिर में चोट",
      image: "https://tse2.mm.bing.net/th/id/OIP._-_srfSlpR_eOeGh-M6wzwHaEo?rs=1&pid=ImgDetMain&o=7&rm=3",
      description: "A head injury is trauma to the scalp, skull, or brain. It can cause headache, dizziness, confusion, memory loss, or unconsciousness, and may require immediate medical evaluation and care.",
      symptoms: ["Headache", "Dizziness", "Confusion", "Nausea"],
      color: "var(--injury-color)"
    },
    {
      id: 5,
      icon: <FaBug />,
      title: "Neurocysticercosis (Brain Worm Infection)",
      hindiTitle: "दिमागी टी.वी. / कीड़े",
      image: "https://tse3.mm.bing.net/th/id/OIP.Z0hDz-vldGYDGDOq3xq6aAHaE8?w=1584&h=1056&rs=1&pid=ImgDetMain&o=7&rm=3",
      description: "Neurocysticercosis is a parasitic brain infection caused by tapeworm larvae. It can lead to seizures, headaches, confusion, or swelling in the brain and requires proper medical diagnosis and treatment.",
      symptoms: ["Seizures", "Headaches", "Confusion", "Vision Problems"],
      color: "var(--infection-color)"
    },
    {
      id: 6,
      icon: <FaHeadphones />,
      title: "Migraine (Headache / Half-head Pain)",
      hindiTitle: "माइग्रेन (सिर दर्द / अधकपारी)",
      image: "https://cannondisability.com/wp-content/uploads/2022/10/AdobeStock_531961549-1024x381.jpeg",
      description: "Migraine is a neurological condition causing intense, throbbing headaches, often on one side. It may be accompanied by nausea, vomiting, and sensitivity to light or sound, lasting hours to days.",
      symptoms: ["Throbbing Pain", "Nausea", "Light Sensitivity", "Visual Auras"],
      color: "var(--migraine-color)"
    },
    {
      id: 7,
      icon: <FaBone />,
      title: "Spine Tumor",
      hindiTitle: "स्पाइन ट्यूमर",
      image: "https://doctorshub.sgp1.cdn.digitaloceanspaces.com/uploads/2024/08/spinal-tumor1.jpg",
      description: "A spine tumor is an abnormal growth in or around the spinal cord. It can cause back pain, numbness, weakness, or difficulty walking, and may require surgery or other treatments.",
      symptoms: ["Back Pain", "Numbness", "Weakness", "Walking Difficulty"],
      color: "var(--spine-color)"
    },
    {
      id: 8,
      icon: <FaBackward />,
      title: "Spondylitis / Sciatica / Slip Disc",
      hindiTitle: "स्पान्डिलाइटिस / सियाटिका / स्लिप-डिस्क",
      image: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
      description: "These spine-related conditions cause back or neck pain, stiffness, and nerve compression. Common symptoms include radiating leg pain, numbness, or restricted movement, managed through physiotherapy, medication, or lifestyle changes.",
      symptoms: ["Back Pain", "Leg Pain", "Numbness", "Stiffness"],
      color: "var(--back-color)"
    },
    {
      id: 9,
      icon: <FaUserInjured />,
      title: "Tingling or Numbness in Hands and Feet",
      hindiTitle: "थ-पैर में झन-झनाहट / नसों का सुन्नपन",
      image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80",
      description: "Tingling or numbness in limbs often indicates nerve compression or damage. It may be caused by diabetes, vitamin deficiency, or neurological issues and requires proper diagnosis and treatment.",
      symptoms: ["Tingling", "Numbness", "Burning Sensation", "Weakness"],
      color: "var(--nerve-color)"
    },
    {
      id: 10,
      icon: <FaBrain />,
      title: "Congenital Tumor (Brain and Spine)",
      hindiTitle: "पैदाइसी गाँठ (सर एवं रीढ़ की हड्डी में)",
      image: "https://pmrxcontent.com/wp-content/uploads/spinal-tumors.jpg",
      description: "Congenital tumors are growths present at birth in the brain or spinal cord. They may affect development, cause neurological symptoms, and often require early diagnosis and medical intervention.",
      symptoms: ["Developmental Delay", "Seizures", "Weakness", "Coordination Issues"],
      color: "var(--congenital-color)"
    },
    {
      id: 11,
      icon: <FaStethoscope />,
      title: "Spinal Injury",
      hindiTitle: "रीढ़ की हड्डी में चोट",
      image:"https://www.advancedreconstruction.com/hs-fs/hubfs/IFAR/spinal-cord-injury.jpg?width=1920&height=1200&name=spinal-cord-injury.jpg",
      description: "A spinal injury is damage to the spinal cord or surrounding bones, often due to trauma. It can cause pain, paralysis, or loss of sensation, requiring immediate medical attention.",
      symptoms: ["Pain", "Paralysis", "Loss of Sensation", "Difficulty Breathing"],
      color: "var(--spinal-color)"
    },
    {
      id: 12,
      icon: <FaEye />,
      title: "Vision Problems / Optic Nerve Disorders",
      hindiTitle: "दृष्टि समस्याएं / ऑप्टिक नर्व विकार",
      image: "https://i.ytimg.com/vi/TEpYN7fb-g0/maxresdefault.jpg?sqp=-oaymwEmCIAKENAF8quKqQMa8AEB-AH-CYAC0AWKAgwIABABGH8gNCgTMA8=&rs=AOn4CLC09woYLjXDfWRdYA8NBMu7v1G8jA",
      description: "Neurological conditions affecting vision including optic neuritis, papilledema, and other optic nerve disorders that can cause blurry vision, eye pain, or vision loss.",
      symptoms: ["Blurry Vision", "Eye Pain", "Vision Loss", "Color Blindness"],
      color: "var(--vision-color)"
    }
  ];

  return (
    <div className="neuro-section">
      {/* Header */}
      <div className="neuro-header">
        <div className="container">
          <div className="header-content">
            <div className="breadcrumb">
              <span>Home</span>
              <FaChevronRight />
              <span className="divider">–</span>
              <span className="current">Medical</span>
              <FaChevronRight />
              <span className="divider">–</span>
              <span className="current">Neuro Diseases & Symptoms</span>
            </div>
            <h1>Neuro Diseases & Symptoms</h1>
            <p className="subtitle">Comprehensive neurological care for various brain and spine conditions</p>
            <div className="stats-container">
             
              <div className="stat-item">
                <FaStethoscope className="stat-icon" />
                <div>
                  <h3>Expert</h3>
                  <p>Neurologists</p>
                </div>
              </div>
              <div className="stat-item">
                <FaMemory className="stat-icon" />
                <div>
                  <h3>Advanced</h3>
                  <p>Diagnostic Tools</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <section className="neuro-content-section">
        <div className="container">
          <div className="section-intro">
            <h2>Neurological Conditions We Treat</h2>
            <p>Our neurology department specializes in diagnosing and treating a wide range of brain, spine, and nerve disorders using advanced medical technology and personalized care approaches.</p>
          </div>
          <div className="neuro-grid">
            {neuroConditions.map((condition) => (
              <div key={condition.id} className="neuro-card">
                <div className="neuro-card-header">
                  <div className="neuro-icon" style={{ color: condition.color }}>
                    {condition.icon}
                  </div>
                  <div className="neuro-title-container">
                    <h3>{condition.title}</h3>
                    <p className="neuro-hindi">{condition.hindiTitle}</p>
                  </div>
                </div>
                
                <div className="neuro-image-container">
                  <img src={condition.image} alt={condition.title} />
                  <div className="neuro-overlay" style={{ backgroundColor: `${condition.color}20` }}></div>
                </div>
                
                <div className="neuro-card-body">
                  <p className="neuro-description">{condition.description}</p>
                  
                  <div className="neuro-symptoms">
                    <h4>Common Symptoms:</h4>
                    <div className="symptoms-list">
                      {condition.symptoms.map((symptom, idx) => (
                        <span key={idx} className="symptom-tag" style={{ backgroundColor: `${condition.color}15` }}>
                          <FaPlus size={10} /> {symptom}
                        </span>
                      ))}
                    </div>
                  </div>
                  
                  <div className="neuro-actions">
                    <button className="neuro-btn consult-btn" style={{ backgroundColor: condition.color }}>
                      <FaStethoscope /> Consult Specialist
                    </button>
                    <button className="neuro-btn learn-btn">
                      Learn More
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="neuro-cta-section">
        <div className="container">
          <div className="cta-content">
            <div className="cta-text">
              <h2>Need Expert Neurological Consultation?</h2>
              <p>Our team of experienced neurologists and neurosurgeons are here to help with diagnosis, treatment, and management of neurological conditions.</p>
            </div>
            <div className="cta-buttons">
              <button className="cta-btn primary-cta">
                <FaPhoneAlt /> Emergency: +91 80903 11155
              </button>
              <button className="cta-btn secondary-cta">
                <FaCalendarAlt /> Book Appointment Online
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default NeuroSection;